import React, { useContext, useEffect, useState } from "react";
import "./Sidebar.css";
import Sidebar_List from "./sidebar_list/Sidebar_List";
import { Button, Offcanvas } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import Notification_Offcanvas from "../common_components/common_offcanvas/notification_offcanvas/Notification_Offcanvas";
import { getNotification } from "../../utils/apis/notification/notification";
import { Context } from "../../utils/context";

const Sidebar = () => {
  const { userdata, signin, headerCompanyName } = useContext(Context);

  const [showSidebar, setShowSidebar] = useState(false);

  const handleClose = () => setShowSidebar(false);
  const handleShow = () => setShowSidebar(true);

  const [show, setShow] = useState(false);

  const [notificationData, setNotificationData] = useState({
    data: [],
    current_page: 1,
    total_pages: 1,
  });

  const closeOffCanvas = () => {
    setShow(false);
  };

  return (
    <>
      <section className="sidebar_main theme_bg">
        <Sidebar_List
          handleClose={handleClose}
          notificationAction={() => setShow(true)}
        />
      </section>

      <Notification_Offcanvas show={show} onHide={closeOffCanvas} />
    </>
  );
};

export default Sidebar;
